export const smtpStatisticsIsLoaded = state => state.smtp.loaded;
export const smtpStatisticsIsLoading = state => state.smtp.loading;
export const smtpStatisticsSelectData = state => state.smtp.data;
export const smtpStatisticsSelectDay = state => state.smtp.day;
export const smtpStatisticsSelectMonth = state => state.smtp.month;
export const smtpStatisticsSelectYear = state => state.smtp.year;
